
function hasOneOf(list, elements) {
    const sourceSet = new Set(elements);
    return list.some(item => sourceSet.has(item));
}

export default hasOneOf;
